<script lang="ts">
    import {Flex} from 'shared/layouts';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import type {SvelteComponentConstructor} from 'core/types';
    import type {ReportDetailOptions} from './types';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {createReportDetailContext} from './report-detail.context';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import {
        ReportFondMachineWithOperator,
        ReportFondWork,
        ReportFondMachine,
        ReportFondAbsence,
        ReportFondOperation,
        ReportFondExecutedWork,
        ReportFondMaterial,
        ReportFondSubsupply
    } from './fond-details';

    export let record: RecordRow;
    export let options: ReportDetailOptions;

    const fondDetailComponents: Record<number, SvelteComponentConstructor> = {
        [FOND_REPORT.MACHINE_WITH_OPERATOR.fond]: ReportFondMachineWithOperator,
        [FOND_REPORT.WORK.fond]: ReportFondWork,
        [FOND_REPORT.MACHINE.fond]: ReportFondMachine,
        [FOND_REPORT.ABSENCE.fond]: ReportFondAbsence,
        [FOND_REPORT.OPERATION.fond]: ReportFondOperation,
        [FOND_REPORT.EXECUTED_WORK.fond]: ReportFondExecutedWork,
        [FOND_REPORT.MATERIAL.fond]: ReportFondMaterial,
        [FOND_REPORT.SUBSUPPLY.fond]: ReportFondSubsupply,
        [FOND_REPORT.SYSTEM_DEVELOPMENT.fond]: ReportFondWork
    };

    createReportDetailContext(options);
</script>

{#if exists(fondDetailComponents[record.fond.id])}
    <Flex class="report-detail" direction="column" gap="xxl">
        {#if exists($$slots.header)}
            <slot name="header" {record}/>
        {/if}

        <svelte:component this={fondDetailComponents[record.fond.id]}
                          on:text-note-edit
                          {record}/>
    </Flex>
{:else}
    <IconedContent icon="exclamation" orientation="vertical" iconColor="var(--danger-red)" fillAvailableSpace>
        <span class="unsupported-report-type">Nepodporovaný typ výkazu ({pipe(record.fond, loc())})</span>
    </IconedContent>
{/if}

<style lang="less">
    .unsupported-report-type {
        color: var(--danger-red);
    }
</style>